import { render } from "./manage-apt.vue?vue&type=template&id=d546647a"
import script from "./manage-apt.vue?vue&type=script&lang=js"
export * from "./manage-apt.vue?vue&type=script&lang=js"

import "./manage-apt.vue?vue&type=style&index=0&id=d546647a&lang=css"

import exportComponent from "/Users/aun/Development/thailand-fest/thai-festival-admin-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__